import { Injectable } from '@angular/core';
import { typeInterface } from '../../Interfaces/company';

interface CacheTimeOut {
  data: any,
  expirationTime: number,
  expirationTimeFormatted: string,
  type: number
}

@Injectable({
  providedIn: 'root'
})
export class CacheService {
  private cacheKeyPrefix = '';
  typeParam: typeInterface = {
    type: 0,
    qrCodeNumber: '',
    numberParam: ''
  }

  setItemLocalTimeout(key: string, data: any, timeoutInMinutes: number): void {
    const cacheKey = this.cacheKeyPrefix + key;

    //Data atual
    const currentTime = new Date();

    //Data de expiração
    const expirationTime = currentTime.getTime() + timeoutInMinutes * 60 * 1000;

    //Data de expiração Formatada
    const expirationTimeFormatted = new Date(expirationTime).toLocaleString('pt-BR')

    //Objeto em cache
    const cacheData: CacheTimeOut = {
      data: data, 
      expirationTime:expirationTime,
      expirationTimeFormatted: expirationTimeFormatted,
      type: this.typeParam.type
    };

    localStorage.setItem(cacheKey, JSON.stringify(cacheData));
  }

  getItemLocalTimeout(key: string): any {
    const cacheDataString = localStorage.getItem(key);

    if (!cacheDataString) {
      return null;
    }

    //Cache local
    const cacheData = JSON.parse(cacheDataString);

    //Data atual
    const currentTime = Date.now();

    if(key != 'product-cart')
    {
      console.log('Horário atual:', new Date(currentTime).toLocaleString('pt-BR'));
      console.log('Horário expiração:',cacheData.expirationTimeFormatted);
    }


    if (currentTime > cacheData.expirationTime) {
      console.log('Removendo carrinho em cache:', `Atual: ${currentTime} | Expiração: ${cacheData.expirationTime}`)
      this.clearCacheTimeout(key);
      return null;
    }

    return cacheData;
  }

  clearCacheTimeout(key: string): void {
    localStorage.removeItem(key);
  }

  setItemLocal(key: string, value: any): void {
    const cacheKey = this.cacheKeyPrefix + key;
    localStorage.setItem(cacheKey, JSON.stringify(value));
  }

  setItemSession(key: string, value: any): void {
    const cacheKey = this.cacheKeyPrefix + key;
    sessionStorage.setItem(cacheKey, JSON.stringify(value));
  }

  getItemLocal(key: string): any {
    const cacheKey = this.cacheKeyPrefix + key;
    const cachedItem = localStorage.getItem(cacheKey);

    if (!cachedItem || cachedItem === "undefined" || cachedItem === "null") {
      return null;
    }

    try {
      return JSON.parse(cachedItem);
    } catch (e) {
      console.error(`Erro ao parsear localStorage[${cacheKey}]`, e);
      return null;
    }
  }


  getItemSession(key: string): any {
    const cacheKey = this.cacheKeyPrefix + key;
    const cachedItem = sessionStorage.getItem(cacheKey);

    if (!cachedItem || cachedItem === "undefined" || cachedItem === "null") {
      return null;
    }

    try {
      return JSON.parse(cachedItem);
    } catch (e) {
      console.error(`Erro ao parsear sessionStorage[${cacheKey}]`, e);
      return null;
    }
  }

  removeItemLocal(key: string): void {
    const cacheKey = this.cacheKeyPrefix + key;
    localStorage.removeItem(cacheKey);
  }

  removeItemSession(key: string): void {
    const cacheKey = this.cacheKeyPrefix + key;
    sessionStorage.removeItem(cacheKey);
  }

  clearCache(): void {
    // Limpa todos os itens do cache relacionados à sua aplicação (opcional).
    Object.keys(sessionStorage).forEach(key => {
      if (key.startsWith(this.cacheKeyPrefix)) {
        localStorage.removeItem(key);
      }
    });
  }

  // private urls: { [domain: string]: string } = {};

  // // Adicione esta função para armazenar a URL com base no domínio
  // storeUrlByDomain(domain: string, url: string): void {
  //   this.urls[domain] = url;
  // }

  // // Adicione esta função para recuperar a URL com base no domínio
  // getUrlByDomain(domain: string): string | null {
  //   return this.urls[domain] || null;
  // }

  // // Adicione esta função para retornar todas as URLs armazenadas no cache
  // getAllUrls(): { [domain: string]: string } {
  //   return this.urls;
  // }


}
